import { useQuery } from '@tanstack/react-query';

import useCurrency from '@/app/hooks/useCurrency';
import { graphql, type ResultOf, type VariablesOf } from '@/graphql';
import gqlClient from '@/utils/gqlClient';

export const query = graphql(`
  query GetOneDiscount($discountCode: String!, $currencyCode: String) {
    content(currency: $currencyCode) {
      discount(discountCode: $discountCode) {
        valid
        invalidReason
        id: discountId
        title
        discountCodes
        appliesTo
        campaign
        grantFreeShipping
        grantSubscription
        usageLimit
        usageCount
        defaultPdpUrl
        priceRules {
          categories
          productKeys
        }
      }
    }
  }
`);

export type GetOneDiscountResult = ResultOf<typeof query>;
export type GetOneDiscountVariables = VariablesOf<typeof query>;

export function withQueryKey(vars: GetOneDiscountVariables) {
  return {
    queryKey: ['fetchDiscount', vars.discountCode, vars.currencyCode],
    queryFn: () => {
      return gqlClient().request(query, vars);
    },
  };
}

export function useDiscount(
  discountCode: GetOneDiscountVariables['discountCode'],
) {
  const { currencyCode } = useCurrency();

  return useQuery({
    ...withQueryKey({
      discountCode,
      currencyCode,
    }),
    enabled: !!discountCode,
  });
}
